module.exports = __webpack_public_path__ + "static/media/1(1).76866355.webp";